import { createSyncEngine } from '$lib/db/sync';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? '';

export const syncEngine = createSyncEngine(apiBaseUrl);
